//  此文件存放业务中的常量
// const DEV = /^dev.+$/.test(document.domain) ? 'dev.' : '';
// const OFFLINE = /^offline.+$/.test(document.domain) ? 'offline.' : '';
// const PREFIX = OFFLINE !=''?OFFLINE:DEV
// const agreement = /^dev.+$/.test(document.domain) ? 'http' : 'https';
// let PROTOCOL = /^offline.+$/.test(window.document.domain)
//     ? 'http'
//     : 'https'

// export const DOMAIN = `${PROTOCOL}://${PREFIX}renwu.longmaosoft.com`;
// export const HTTPDOMAIN = `http://${PREFIX}renwu.longmaosoft.com`;
// export const DOMAIN_LREGISTER = `https://${PREFIX}renwu.longmaosoft.com/register`;
// export const OLD_DOMAIN = 'http://renwu.old.longmaosoft.com';
// export const SERVER_HOST = `${PROTOCOL}://${PREFIX}server.h5.longmaosoft.com`
// export const NEW_SERVER_HOST = `https://${PREFIX}api.service.longmaosoft.com`;

export const DOMAIN = process.env.VUE_APP_URL_RENWU;
export const HTTPDOMAIN = process.env.VUE_APP_URL_RENWU_HTTP;
export const SERVER_HOST = process.env.VUE_APP_SERVER
export const NEW_SERVER_HOST = process.env.VUE_APP_API;
export const JIDU_DOMAIN = process.env.VUE_APP_URL_JIDU

export const SITE_TITLE = '龙猫众包';
// 分页查询约定
export const PAGINATION_PARAM = {
  page: 1, // 当前页码
  pagesize: 20, // 每页展示的数据条数
};
// 考核状态  练习 快判
export const taskStatusList: object[] = [
  {
    label: '全部',
    value: '2',
  },
  {
    label: '考核通过任务',
    value: '1',
  },
  {
    label: '待考核任务',
    value: '0',
  },
];
// 参与状态 普通
export const partakeList: object[] = [
  {
    label: '全部',
    value: '2',
  },
  {
    label: '已参与',
    value: '1',
  },
  {
    label: '未参与',
    value: '0',
  },
];
// 领取状态 团队
export const teamStatusList: object[] = [
  {
    label: '全部',
    value: '2',
  },
  {
    label: '已领取',
    value: '1',
  },
  {
    label: '未领取',
    value: '0',
  },
];
export const taskTypeList: object[] = [
  {
    label: '标注任务',
    value: '1',
  },
  {
    label: '快判任务',
    value: '2',
  },
];
//任务要求: 团队
export const teamRequireList: object[] = [
  {
    label: '全部',
    value: '2',
  },
  {
    label: '我的团队满足要求',
    value: '1',
  },
  {
    label: '我的团队不满足要求',
    value: '0',
  }
];
//任务要求: 普通 指定
export const crowdRequireList: object[] = [
  {
    label: '全部',
    value: '2',
  },
  {
    label: '我的经验值满足要求',
    value: '1',
  },
  {
    label: '我的经验值不满足要求',
    value: '0',
  }
]
//任务类型: 团队 普通 指定
export const crowdTypeList: object[] = [
  {
    value: '0',
    label: '全部'
  },
  {
    value: '2',
    label: '标注任务',
  },
  {
    value: '4',
    label: '快判任务',
  },
  {
    value: '9',
    label: '筛选任务',
  },
  {
    value: '3',
    label: '文字转写',
  },
  {
    value: '1',
    label: '打点计数',
  },
  {
    value: '5',
    label: '审核任务',
  },
  {
    value: '6',
    label: '质检任务',
  },
  {
    value: '7',
    label: '平台任务',
  },
  // {
  //   value: '8',
  //   label: '采集任务',
  // },
];
// 任务排序 团队 普通
export const sortList: object[] = [
  // {
  //   label: '默认排序',
  //   value: '0',
  // },
  {
    label: '按发布时间排序',
    value: '3',
  },
  {
    label: '按任务单价排序',
    value: '1',
  },
  {
    label: '按任务总价排序',
    value: '2',
  },
  {
    label: '按做题人数排序',
    value: '4'
  }
];
export const practiceList: object[] = [
  {
    label: '拉框类',
    value: '0',
  },
  {
    label: '打点类',
    value: '1',
  },
  {
    label: '语义分割类',
    value: '2',
  },
  {
    label: '文本类',
    value: '3',
  },
  {
    label: '语音类',
    value: '4',
  },
  {
    label: '转写类',
    value: '5',
  },
  {
    label: '审核类',
    value: '6',
  },
];
//我的任务（指定任务）
export const myAuthList: object[] = [
  {
    label: '全部',
    value: '2',
  },
  {
    label: '指定我参与',
    value: '1',
  },
  {
    label: '未指定我参与',
    value: '0',
  }
];
//经验值
export const expRequireList: object[] = [
  {
    label: '全部',
    value: '2',
  },
  {
    label: '满足要求',
    value: '1',
  },
  {
    label: '不满足要求',
    value: '0',
  }
];
// TODO 不登录不能拿到category接口返回值 就不能看列表 需设置初始值
export const initCategory: object = {
  2: '语音类',
  3: '文本类',
  5: '打点语义分割类',
  7: '打关键点类',
  11: '拉框类',
  13: '转写类',
  17: '筛选',
  19: '内部审核',
  29: '保险类文本-标注',
  31: '保险类文本-快判',
  37: 'PS',
  41: '3D box',
  43: '审核',
  53: '超像素语义分割类'
};

export const taskMap: object ={
  0:{
    label: '普通任务',
    value: 'crowd'
  },
  1:{
    label: '团队任务',
    value: 'team'
  },
  2:{
    label: '练习任务',
    value: 'train'
  },
  3:{
    label: '指定任务',
    value: 'authUser'
  }
}

export const collectTypes: object[] = [
  {
    label: '全部',
    value: '0'
  },
  {
    label: '图片',
    value: 'collectImage'
  },
  {
    label: '文本',
    value: 'collectText'
  },
  {
    label: '音频',
    value: 'collectAudio'
  },
  {
    label: '视频',
    value: 'collectVideo'
  }
]

export const mobileProject = [
  10522,
  10523,
  10524,
  10832,
  10833,
  10834,
  12035,
  12036,
  12037,
  12002,
  12003,
  12004,
  12115,
  12116,
  12117,
  12433,
  12434,
  12435,
  12436,
  12437,
  12438,
  12439,
  12440,
  12441,
  12442,
  12443,
  12444,
  12445,
  12446,
  12447,
  12448,
  12449,
  12450,
  12451,
  12452,
  12453,
  12454,
  12455,
  12456,
  12457,
  12458,
  12459,
  14225,
  14226,
  14227,
  14252,
  14253,
  14254,
  14255,
  14256,
  14257,
  14375,
  14376,
  14377,
]
